module.exports = __webpack_public_path__ + "static/3c-f2503bc25775e3b9486c50c08ae669d3.png";